import React from "react";
import "./ContactsHero.css";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock, FaFacebookF, FaTwitter, FaYoutube } from "react-icons/fa";

const ContactsHero = () => {
  return (
    <section className="contact-hero">
      <div className="grid-pattern"></div>

      <div className="hero-container">
        <div className="hero-header">
          <span className="hero-badge">CONTACT US</span>
          <h1>Get in touch with us</h1>
          <p>
            Whether you have a question, need support, or want to learn more about how our services can help you, we’re here to assist you.
          </p>
        </div>

        <div className="contact-main">
          <form className="contact-form">
            

            <div className="form-group">
              <label>Full Name</label>
              <input type="text" placeholder="Enter Name" />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" placeholder="email@gmail.com" />
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea placeholder="Write Something"></textarea>
            </div>

            <button type="submit" className="send-btn">Send Message</button>
          </form>

          <div className="contact-info">
            <h3>Contact Info</h3>
            <p>
              we are committed in providing the highest
standard of medical services and cutting-edge consultancy.
            </p>
            <ul>
              <li><FaMapMarkerAlt /> Diamond Plaza, 2nd Floor</li>
              <li><FaPhoneAlt /> +254 20 5226693</li>
              <li><FaEnvelope /> info@simbaeducationconsultants.org</li>
              <li><FaClock /> Mon–Sat: 8 AM–8 PM</li>
            </ul>
            <div className="social-icons">
              <a href="/"><FaFacebookF /></a>
              <a href="/"><FaTwitter /></a>
              <a href="/"><FaYoutube /></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactsHero;
